import React from "react";
import { useSelector } from "react-redux";
import { SxStyleProp } from "theme-ui";
import { navigate } from "@reach/router";
import { RootState } from "@pacerpro/admin/typings";
import { FolderIcon, SearchIcon, RssIcon, SettingsIcon } from "../icons";
import Anchor from "../Anchor/Anchor";
import Box from "../Box/Box";
import Flex from "../Flex/Flex";
import Text from "../Text/Text";
import Image from "../Image/Image";
import { Popover, PopoverTrigger, PopoverContent } from "../Popover";
import { useToggle } from "../../hooks/useToggle";
const logo = require("./logo.svg");

const IconButton: React.FunctionComponent<{
  sx?: SxStyleProp;
  href?: string;
  onClick?: () => void;
}> = ({ sx, ...restProps }) => (
  <Anchor
    sx={{
      cursor: "pointer",
      display: "flex",
      p: 4,
      color: "white",
      borderRight: "1px solid #979797",
      ...(sx as any),
    }}
    {...restProps}
  />
);

const SettingsButton: React.FunctionComponent<{
  sx?: SxStyleProp;
  onClick: () => void;
}> = ({ sx, ...restProps }) => (
  <Box
    sx={{
      cursor: "pointer",
      display: "flex",
      p: 4,
      color: "white",
      borderRight: "1px solid #979797",
      ...(sx as any),
    }}
    {...restProps}
  />
);

const SettingsLink: React.FunctionComponent<{
  sx?: SxStyleProp;
  href?: string;
  onClick?: () => void;
}> = ({ sx, ...restProps }) => (
  <Anchor
    sx={{
      cursor: "pointer",
      display: "flex",
      width: "100%",
      whiteSpace: "nowrap",
      px: 6,
      py: 2,
      ...(sx as any),
    }}
    {...restProps}
  />
);

const Settings: React.FunctionComponent = () => {
  const { isOpen, onOpen, onClose, onToggle } = useToggle();
  return (
    <Popover isOpen={isOpen} onClose={onClose} onOpen={onOpen}>
      <PopoverTrigger>
        <SettingsButton
          onClick={onToggle}
          sx={{
            borderRight: 0,
            borderLeft: "1px solid #979797",
          }}
        >
          <SettingsIcon sx={{ stroke: "white" }} />
        </SettingsButton>
      </PopoverTrigger>
      <PopoverContent initialPlacement="bottom-end">
        <Flex
          onClick={onToggle}
          direction="column"
          align="flex-end"
          sx={{
            width: "200px",
            position: "absolute",
            border: "1px solid",
            borderColor: "border",
            right: "-5px",
            backgroundColor: "#fff",
          }}
        >
          <SettingsLink href="/accounts/edit">Profile</SettingsLink>
          <SettingsLink href="/admin">Admin</SettingsLink>
          <SettingsLink
            onClick={() => navigate("/mycases")}
            sx={{ borderTop: "1px solid", borderColor: "border" }}
          >
            Return to My Cases
          </SettingsLink>
        </Flex>
      </PopoverContent>
    </Popover>
  );
};

const HeaderStart: React.FunctionComponent<{}> = props => (
  <Flex as="header" {...props}>
    <IconButton href="/mycases">
      <FolderIcon sx={{ fill: "white" }} />
    </IconButton>
    <IconButton href="/searches/new">
      <SearchIcon sx={{ fill: "white" }} />
    </IconButton>
    <IconButton href="/mycases/feed">
      <RssIcon sx={{ stroke: "white" }} />
    </IconButton>
  </Flex>
);

const HeaderEnd: React.FunctionComponent<{}> = props => {
  const session = useSelector((state: RootState) => state.session);
  return (
    <Flex align="center" {...props}>
      <Text mr={1}>
        {session.firstName} {session.lastName}
      </Text>
      {/* <IconButton
        sx={{ border: 0 }}
        onClick={() => signOut().then(() => navigate("/accounts/sign_in"))}
      >
        <LogOutIcon sx={{ fill: "white" }} />
      </IconButton> */}
      <Settings />
    </Flex>
  );
};

const HeaderLogo: React.FunctionComponent<{}> = () => (
  <Image sx={{ maxWidth: 150 }} src={logo} alt="PacerPro Logo" />
);

interface Props {
  sx?: SxStyleProp;
}

const AppHeader: React.FunctionComponent<Props> = ({ sx, ...restProps }) => (
  <Flex
    justify="space-between"
    align="center"
    sx={{ bg: "text", color: "white" }}
    {...restProps}
  >
    <HeaderStart />
    <HeaderLogo />
    <HeaderEnd />
  </Flex>
);

export default AppHeader;
